<template>
	<div class="ImageUploadView" :class="{
		...modes.map((m) => `ImageUploadView--${m}`),
		'ImageUploadView--withRemove': showRemove,
		'u-ErrorView': hasError,
		'ImageUploadView--error': isError,
		isLoader: isLoader
	}">
		<div class="ImageUploadViewCaption" v-if="title">
			{{ title }}
		</div>

		<div class="ImageUploadViewInner" @dragover.prevent @drop="onDrop" :style="innerStyles">
			<label class="FullEditView ImageUploadViewLabel">
				<div class="ImageUploadViewLabelContent">
					<span v-show="!isLoader" class="ImageUploadViewLabelText">
						<slot></slot>
					</span>
					<input type="file" name="file" class="ImageUploadViewInput" @change="onSelect" />
				</div>

				<slot name="edit" v-if="hasEdit">
					<edit-view></edit-view>
				</slot>
			</label>

			<div alt="" class="ImageUploadViewPreview" :style="{
				backgroundSize: objectFit,
				backgroundImage: imgUrl && `url(${imgUrl})`,
			}"></div>

			<slot name="overlay"></slot>
			<slot name="remove" v-if="showRemove">
				<remove-view @click="onRemove"></remove-view>
			</slot>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "ImageUploadView",
	mixins: [mixins.ValidationComponentMixin],
	props: {
		tnKey: {
			type: String,
			default: ""
		},
		value: {
			type: Object,
			default: () => { },
		},
		defaultImageUrl: {
			type: String,
			default: ""
		},
		modes: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: ""
		},
		caption: {
			type: String,
			default: ""
		},
		hasEdit: {
			type: Boolean,
			default: false
		},
		hasRemove: {
			type: Boolean,
			default: false
		},
		isError: {
			type: Boolean,
			default: false
		},
		isConvertToJPEG: {
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: '100%'
		},
		height: {
			type: String,
			default: '400px'
		},
		otherStyles: {
			type: Object,
			default: () => { }
		},
		objectFit: {
			type: String,
			default: "cover"
		},
	},
	data() {
		return {
			isLoader: false,
		};
	},
	computed: {
		innerStyles() {
			return {
				width: this.width,
				height: this.height,
				...this.otherStyles
			}
		},

		showRemove() {
			return this.hasRemove && this.innerValue;
		},

		imgUrl() {
			let url = ''
			if (this.innerValue) {
				url = this.tnKey !== ''
					? this.innerValue[this.tnKey]
					: Object.values(this.innerValue)[0]

				if (this.innerValue.s3_url) {
					url = this.innerValue.s3_url
				}
			}

			if (url === undefined) {
				url = this.innerValue.url
			}

			return url
		},
	},
	methods: {
		onRemove() {
			this.innerValue = null;
		},

		onDrop(e) {
			e.stopPropagation();
			e.preventDefault();

			this.takeFile(e.dataTransfer.files[0]);
		},

		onSelect(e) {
			this.takeFile(e.target.files[0]);
		},

		takeFile(file) {
			if (!file || !file.type) {
				return;
			}

			if (!file.type.match("image.*")) {
				alert("Select an image");
				return;
			}

			this.$emit('image', file)
			this.$emit('copyImage', file)
			this.uploadFile(file);
		},

		async uploadFile(file) {
			this.isLoader = true;

			const parts = file.name.split(".");
			const name = parts[0];

			let data = new FormData();
			data.append("file", file, this.isConvertToJPEG ? `${name}.tiff` : file.name);

			let config = {
				headers: { "Content-Type": "multipart/form-data" },
			};

			await axios
				.post('/control/upload_temp_file/', data, config)
				.then((response) => {
					this.innerValue = response.data;
				})
				.catch((error) => {
					console.log(error);
					alert(error);
				});

			this.isLoader = false;
		},
	},
};
</script>

<style scoped lang="less">
@import "~styles/const.less";
@import "~styles/styles.less";

@r: .ImageUploadView;

@{r} {
	position: relative;
	height: fit-content;

	&.isLoader {
		&:before {
			content: ' ';
			display: block;
			.cLoader(70px, black);
		}
	}

	&Inner {
		position: relative;
		background-color: white;
		border: 1px solid black;
	}

	&Label {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
		cursor: pointer;

		&:hover &Content {
			background-color: rgba(#d9d9d9, 0.25);
		}

		&Content {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			transition: opacity 0.2s;
			cursor: pointer;
		}

		&Text {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			cursor: pointer;
			font-size: 12px;
			font-style: normal;
			font-weight: 400;
			line-height: 16px;
			color: black;
			width: 100%;
		}
	}

	&Input {
		display: none;
	}

	&Preview {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
	}

	&Caption {
		display: inline-block;
		font-size: 12px;
		line-height: 16px;
		color: black;
		margin-bottom: 10px;
	}

	&--withRemove {
		.RemoveView {
			top: 10px;
			left: auto;
			right: 10px;

			:deep(.RemoveViewButton) {
				width: 20px;
				height: 20px;
			}
		}

		.EditView {
			right: 60px !important;
		}
	}

	&--error {
		@{r}Label {
			border: 1px solid @color-red;
		}
	}
}

.u-ShowErrors @{r}.u-ErrorView @{r}Inner {
	border: 1px solid red;
}
</style>
